/**
 * Container Scroll Effect
 * https://inspira-ui.com/docs/components/miscellaneous/container-scroll
 * 3D scroll effect with rotation, scale, and translation
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function initContainerScroll() {
  const containers = document.querySelectorAll('.container-scroll');
  
  if (containers.length === 0) return;
  
  containers.forEach(container => {
    const card = container.querySelector('.container-scroll-card');
    const title = container.querySelector('.container-scroll-title');
    
    if (!card || !title) return;
    
    const isMobile = window.innerWidth <= 768;
    
    const rotateValue = parseFloat(container.dataset.rotate) || 20;
    const scaleStart = parseFloat(container.dataset.scaleStart) || (isMobile ? 0.7 : 1.05);
    const scaleEnd = parseFloat(container.dataset.scaleEnd) || 1;
    const translateYValue = parseFloat(container.dataset.translateY) || -100;
    
    gsap.set(card, {
      rotationX: rotateValue,
      scale: scaleStart,
      transformStyle: 'preserve-3d',
      force3D: true,
    });
    
    gsap.set(title, {
      y: 0,
      transformStyle: 'preserve-3d',
      force3D: true,
    });
    
    // Use onUpdate for reliable sync with Lenis
    ScrollTrigger.create({
      trigger: container,
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.5,
      onUpdate: (self) => {
        const p = self.progress;
        const rotationX = rotateValue * (1 - p);
        const scale = scaleStart + (scaleEnd - scaleStart) * p;
        const y = translateYValue * p;
        gsap.set(card, {
          rotationX,
          scale,
          force3D: true,
        });
        gsap.set(title, {
          y,
          force3D: true,
        });
      },
    });
  });
}

export { initContainerScroll };

